import { render, staticRenderFns } from "./ShiftList.vue?vue&type=template&id=721f596f&scoped=true"
import script from "./ShiftList.vue?vue&type=script&lang=js"
export * from "./ShiftList.vue?vue&type=script&lang=js"
import style0 from "./ShiftList.vue?vue&type=style&index=0&id=721f596f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721f596f",
  null
  
)

export default component.exports